// @ts-nocheck
/**
 * pablo-datasheet.js
 * Specification Sheet generator — portrait A3
 * Perf: jsPDF preloaded on init, all images JPEG-compressed & downscaled, parallel fetch
 */

(function () {
  if (window._pabloDatasheetInit) return;
  window._pabloDatasheetInit = true;

  // ── Preload jsPDF immediately so it's ready when the user clicks ──────────
  var _jspdfPromise = (function () {
    if (window.jspdf) return Promise.resolve(window.jspdf);
    return new Promise(function (resolve, reject) {
      var s = document.querySelector('script[data-pablo-jspdf]');
      if (!s) {
        s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
        s.setAttribute('data-pablo-jspdf', '1');
        document.head.appendChild(s);
      }
      s.addEventListener('load', function () { resolve(window.jspdf); });
      s.addEventListener('error', function () { reject(new Error('jsPDF failed to load')); });
    });
  })();

  // ── Fetch + downscale + compress an image to a { data, fmt } object ───────
  function fetchImage(url, maxPx, asJpeg, quality) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        var scale = maxPx ? Math.min(1, maxPx / Math.max(img.width || 1, img.height || 1)) : 1;
        var c = document.createElement('canvas');
        c.width  = Math.max(1, Math.round(img.width  * scale));
        c.height = Math.max(1, Math.round(img.height * scale));
        var ctx = c.getContext('2d');
        if (asJpeg) { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height); }
        ctx.drawImage(img, 0, 0, c.width, c.height);
        var mime = asJpeg ? 'image/jpeg' : 'image/png';
        resolve({ data: c.toDataURL(mime, asJpeg ? (quality || 0.75) : undefined), fmt: asJpeg ? 'JPEG' : 'PNG' });
      };
      img.onerror = function () { resolve(null); };
      img.src = url.split('?')[0];
    });
  }

  var _el = document.createElement('textarea');
  function clean(s) {
    if (!s) return '';
    _el.innerHTML = s;
    return _el.value.replace(/\s+/g, ' ').trim();
  }

  // ── Track current variant (SKU + options) ─────────────────────────────────
  var _cfg     = window.PabloDatasheetConfig || {};
  var _sku     = _cfg.productSku || '';
  var _options = (_cfg.variantOptions || []).slice();

  document.addEventListener('variant:update', function (e) {
    var v = e.detail && e.detail.resource;
    if (!v) return;
    _sku = v.sku || '';
    if (Array.isArray(v.options) && _options.length) {
      _options = _options.map(function (o, i) {
        return { name: o.name, value: v.options[i] !== undefined ? v.options[i] : o.value };
      });
    }
  });

  // ── PDF generation ────────────────────────────────────────────────────────
  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('#PabloSheetButton, [data-pablo-sheet-trigger]');
    if (!btn) return;

    var cfg      = window.PabloDatasheetConfig || {};
    var lbl      = btn.querySelector('#PabloSheetButtonLabel, [data-pablo-sheet-label]') || btn;
    var origText = lbl.innerText;
    lbl.innerText = 'Generating…';
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.45';

    try {
      var jspdfLib = await _jspdfPromise;
      // A3 portrait: 297 × 420 mm
      var doc = new jspdfLib.jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a3' });

      // ── Page geometry (A3: 297 × 420 mm) ──────────────────────────────────
      var M  = 12;
      var PW = 297, PH = 420;
      var CW = PW - M * 2;     // 269 mm content width

      var LC  = 90, LX = M;    // left column: 90 mm
      var GAP = 6;
      var RC  = CW - LC - GAP; // right column: 173 mm
      var RX  = M + LC + GAP;  // 110 mm

      var HDR_LINE = 30;            // header separator y
      var CT       = HDR_LINE + 4;  // content top y = 34
      var FTR_LINE = PH - 12;       // footer separator y = 408
      var MAX_Y    = FTR_LINE - 4;  // last usable y = 404

      // ── Collect Features ──────────────────────────────────────────────────
      var featureRichEl = document.querySelector('.feature-info-description .metafield-rich_text_field');

      var featureLines = featureRichEl
        ? Array.from(featureRichEl.querySelectorAll('p, li, h1, h2, h3, h4, h5'))
            .map(function (el) { return el.innerText.trim(); })
            .filter(Boolean)
        : [];

      if (featureLines.length === 0) {
        featureLines = Array.from(document.querySelectorAll('.feature-info-body'))
          .map(function (item) {
            var t = item.querySelector('.feature-info-body-title');
            var b = item.querySelector('.feature-info-body-specbody');
            return (t && t.innerText.trim()) || (b && b.innerText.trim()) || '';
          })
          .filter(Boolean);
      }

      // ── Fetch everything in parallel ───────────────────────────────────────
      var logoEl = document.querySelector(
        '.header__heading-logo, .header__logo img, .header-logo img, ' +
        '.site-header img[class*="logo"], header img[class*="logo"]'
      );
      var productEls = Array.from(
        document.querySelectorAll('.product-media-container img')
      ).filter(function (i) { return !i.closest('dialog'); });
      var specEl = document.querySelector('.spec-image');

      var fetched = await Promise.all([
        fetchImage(logoEl        ? logoEl.src        : null, 300,  false),
        fetchImage(productEls[0] ? productEls[0].src : null, 1000, true,  0.82),
        fetchImage(productEls[1] ? productEls[1].src : null, 900,  true,  0.80),
        fetchImage(specEl        ? specEl.src        : null, 1400, false),
      ]);

      var iLogo = fetched[0];
      var iP1   = fetched[1];
      var iP2   = fetched[2];
      var iSpec = fetched[3];

      // ── Render helpers ─────────────────────────────────────────────────────
      function putImg(obj, x, y, w, h) {
        if (!obj) return;
        doc.addImage(obj.data, obj.fmt, x, y, w, h, undefined, 'FAST');
      }

      function imgFit(obj, maxW, maxH) {
        if (!obj) return null;
        var p = doc.getImageProperties(obj.data);
        var w = maxW, h = (p.height * w) / p.width;
        if (h > maxH) { h = maxH; w = (p.width * h) / p.height; }
        return { w: w, h: h };
      }

      // ── HEADER ─────────────────────────────────────────────────────────────
      if (iLogo) {
        var lf = imgFit(iLogo, 28, 11);
        if (lf) putImg(iLogo, LX, M, lf.w, lf.h);
        doc.setFontSize(9); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
        doc.text('SELECTED CONFIGURATION', LX, M + (lf ? lf.h : 14) + 5);
      } else if (cfg.shopName) {
        doc.setFontSize(22); doc.setFont('helvetica', 'bold'); doc.setTextColor(10, 10, 10);
        doc.text(cfg.shopName.toUpperCase(), LX, M + 14);
        doc.setFontSize(9); doc.setFont('helvetica', 'bold'); doc.setTextColor(0, 0, 0);
        doc.text('SELECTED CONFIGURATION', LX, M + 24);
      }

      doc.setDrawColor(152, 154, 154); doc.setLineWidth(0.2646);
      doc.line(M, HDR_LINE, PW - M, HDR_LINE);

      // ── LEFT COLUMN: product images ────────────────────────────────────────
      var LY = CT;

      [{ obj: iP1, maxH: 130 }, { obj: iP2, maxH: 95 }].forEach(function (entry) {
        if (!entry.obj || LY >= MAX_Y) return;
        var f = imgFit(entry.obj, LC, entry.maxH);
        if (!f) return;
        putImg(entry.obj, LX + (LC - f.w) / 2, LY, f.w, f.h);
        LY += f.h + 7;
      });


      // ── RIGHT COLUMN ───────────────────────────────────────────────────────
      var RY = CT;
      var lhBody  = 9 * 0.352778 * 1.4;    // ~4.45 mm
      var lhLabel = 8 * 0.352778 * 1.3;    // ~3.67 mm

      var title = clean(cfg.productTitle || '');
      var desc  = clean(cfg.productDescription || '');
      var sku   = _sku || cfg.productSku || '';
      var opts  = _options.length ? _options : (cfg.variantOptions || []);
      var specs = cfg.specs || [];

      // Product title
      doc.setFontSize(16); doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 15, 15);
      var tLines = doc.splitTextToSize(title, RC);
      doc.text(tLines, RX, RY + 16 * 0.352778 * 0.85);
      RY += tLines.length * (16 * 0.352778 * 1.35) + 2;

      // Description — render all lines, keep room for config below
      if (desc) {
        doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(60, 60, 60);
        var dLines = doc.splitTextToSize(desc, RC);
        for (var di = 0; di < dLines.length; di++) {
          if (RY > MAX_Y - 100) break;
          doc.text(dLines[di], RX, RY);
          RY += lhBody;
        }
        RY += 6;
      }

      // Section header helper (right column)
      function secHead(text) {
        if (RY > MAX_Y - 20) return false;
        doc.setFontSize(9.5); doc.setFont('helvetica', 'bold'); doc.setTextColor(30, 30, 30);
        doc.text(text, RX, RY); RY += 3;
        doc.setDrawColor(152, 154, 154); doc.setLineWidth(0.2646);
        doc.line(RX, RY, RX + RC, RY); RY += 6;
        return true;
      }

      // Selected Configuration
      var visibleOpts = opts.filter(function (o) {
        return o.name && o.value && o.value !== 'Default Title';
      });
      if (sku) visibleOpts.unshift({ name: 'Product Code', value: sku });

      if (visibleOpts.length > 0 && secHead('SELECTED CONFIGURATION')) {
        doc.setFontSize(9);
        var cfgLineH = 9 * 0.352778 * 1.6;
        visibleOpts.forEach(function (o) {
          if (RY > MAX_Y - 6) return;
          var labelText = o.name + ': ';
          doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
          doc.text(labelText, RX, RY);
          var labelW = doc.getTextWidth(labelText);
          doc.setFont('helvetica', 'bold'); doc.setTextColor(15, 15, 15);
          doc.text(String(o.value), RX + labelW, RY);
          RY += cfgLineH;
        });
        RY += 1;
      }

      // ── Materials (from specifications accordion) ──────────────────────────
      var materialsText = '';
      var specsAcc = document.querySelector('.specifications-accordion');
      if (specsAcc) {
        var mParas = specsAcc.querySelectorAll('.spec-info-description .metafield-rich_text_field p');
        for (var mi = 0; mi < mParas.length && !materialsText; mi++) {
          var mParts = mParas[mi].innerHTML.split(/<br\s*\/?>/i);
          for (var mj = 0; mj < mParts.length; mj++) {
            // clean() decodes entities but keeps tags; the label is wrapped in <strong>
            var mClean = clean(mParts[mj].replace(/<[^>]*>/g, ''));
            if (/^materials\s*:/i.test(mClean)) {
              materialsText = mClean.replace(/^materials\s*:/i, '').trim();
              break;
            }
          }
        }
      }

      // ── SPECIFICATIONS: image top (dynamic fit), rows below ──────────────
      RY += 5;
      if ((specs.length > 0 || iSpec || materialsText) && secHead('SPECIFICATIONS')) {

        // Materials: bold inline label, copy continues on the same line and wraps to full width
        if (materialsText) {
          doc.setFontSize(9); doc.setFont('helvetica', 'bold'); doc.setTextColor(30, 30, 30);
          var mLabel  = 'Materials: ';
          var mLabelW = doc.getTextWidth(mLabel);
          doc.text(mLabel, RX, RY);

          doc.setFont('helvetica', 'normal');
          var mFirst = doc.splitTextToSize(materialsText, RC - mLabelW);
          var mRest  = mFirst.slice(1).join(' ');
          var mLines = [mFirst[0] || ''].concat(mRest ? doc.splitTextToSize(mRest, RC) : []);
          mLines.forEach(function (ln, li) {
            doc.text(ln, li === 0 ? RX + mLabelW : RX, RY);
            RY += lhBody;
          });
          RY += 6;
        }

        // Dynamic image: shrinks when there are many spec rows to keep everything on one page
        if (iSpec) {
          var specImgMaxH = specs.length > 9 ? 75 : specs.length > 5 ? 82 : 88;
          var specImgMaxW = specs.length > 9 ? 115 : specs.length > 5 ? 118 : 120;
          var sf = imgFit(iSpec, specImgMaxW, specImgMaxH);
          if (sf && RY + sf.h < MAX_Y - 40) {
            putImg(iSpec, RX + (RC - sf.w) / 2, RY, sf.w, sf.h);
            RY += sf.h + 5;
          }
        }

        // Rows use the full right-column width below the image
        var specRowX = RX;
        var specRowW = RC;
        var rowPad   = specs.length > 9 ? 2 : 3;
        var rowBot   = specs.length > 9 ? 2 : 3;
        doc.setFontSize(9);

        specs.forEach(function (item) {
          if (!item.label || RY > MAX_Y - 8) return;

          var rowLabel = clean(item.label);
          var rowValue = clean(item.value || '');
          var vLines   = doc.splitTextToSize(rowValue, specRowW * 0.5);
          var rowH     = rowPad + Math.max(vLines.length, 1) * lhBody + rowBot;

          doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
          doc.text(rowLabel, specRowX, RY + rowPad + lhBody * 0.85);

          doc.setTextColor(30, 30, 30);
          vLines.forEach(function (ln, li) {
            doc.text(ln, specRowX + specRowW, RY + rowPad + lhBody * (0.85 + li), { align: 'right' });
          });

          RY += rowH;
          doc.setDrawColor(210, 210, 210); doc.setLineWidth(0.18);
          doc.line(specRowX, RY, specRowX + specRowW, RY);
          RY += 0.6;
        });
      }


      // ── FEATURES: right column, below specifications ───────────────────────
      RY += 18;
      if (featureLines.length > 0 && secHead('FEATURES')) {
        doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(30, 30, 30);

        var n       = featureLines.length;
        var fCols   = n <= 5 ? 1 : n <= 10 ? 2 : 3;
        var fColGap = 7;
        var fColW   = (RC - fColGap * (fCols - 1)) / fCols;
        var fLineH  = 9 * 0.352778 * 1.35;
        var fGap    = 7;
        var perCol  = Math.ceil(n / fCols);

        var fWrapped = featureLines.map(function (text) {
          return text ? doc.splitTextToSize(text, fColW) : [];
        });

        // Row height follows the tallest item across columns so rows stay aligned
        var rowTop = [];
        var fY = RY;
        for (var r = 0; r < perCol; r++) {
          rowTop.push(fY);
          var maxL = 1;
          for (var c = 0; c < fCols; c++) {
            var w = fWrapped[c * perCol + r];
            if (w && w.length > maxL) maxL = w.length;
          }
          fY += maxL * fLineH + fGap;
        }
        rowTop.push(fY);

        featureLines.forEach(function (text, idx) {
          var col  = Math.floor(idx / perCol);
          var row  = idx % perCol;
          var xPos = RX + col * (fColW + fColGap);
          var yPos = rowTop[row];
          if (yPos > MAX_Y - 6 || !text) return;
          doc.setFont('helvetica', 'normal');
          fWrapped[idx].forEach(function (ln, li) {
            doc.text(ln, xPos, yPos + fLineH * (0.85 + li));
          });
        });

        RY = fY;
      }

      // ── FOOTER ─────────────────────────────────────────────────────────────
      var nPages = doc.internal.getNumberOfPages();
      for (var p = 1; p <= nPages; p++) {
        doc.setPage(p);
        doc.setDrawColor(152, 154, 154); doc.setLineWidth(0.2646);
        doc.line(M, FTR_LINE, PW - M, FTR_LINE);
        if (cfg.shopName) {
          doc.setFontSize(8.5); doc.setFont('helvetica', 'normal'); doc.setTextColor(110, 110, 110);
          doc.text(cfg.shopName, PW / 2, FTR_LINE + 5, { align: 'center' });
        }
      }

      // ── Save ───────────────────────────────────────────────────────────────
      var fn = (cfg.productHandle || title || 'Product')
        .replace(/[^a-z0-9_\-]/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
      doc.save(fn + '-Spec-Sheet.pdf');

    } catch (err) {
      console.error('[pablo-datasheet]', err);
      alert('Could not generate the specification sheet. Please try again.');
    } finally {
      lbl.innerText = origText;
      btn.style.pointerEvents = '';
      btn.style.opacity = '';
    }
  });
})();
